module.exports = __webpack_public_path__ + "static/media/CreateBlue.9f2c391b.svg";